/**
 * Etiqueta de cliente/proveedor A3 con código delante del nombre.
 * Evita ambigüedad cuando hay homónimos (p. ej. Scalpers id 4 vs 18).
 */
export function formatA3PartyLabel(code, name) {
  const cod = String(code ?? "").trim();
  const nom = String(name ?? "").trim();
  if (cod && nom) {
    const nomUpper = nom.toUpperCase();
    const codUpper = cod.toUpperCase();
    if (
      nomUpper === codUpper ||
      nomUpper.startsWith(`${codUpper} ·`) ||
      nomUpper.startsWith(`${codUpper} -`) ||
      nomUpper.startsWith(`${codUpper}—`) ||
      nomUpper.startsWith(`(${codUpper})`) ||
      nomUpper.startsWith(`${codUpper} `)
    ) {
      return nom;
    }
    return `${cod} · ${nom}`;
  }
  return nom || cod || "";
}

/** Sufijo `-2`, `-3`… según referencias ya guardadas (no `rows.length`, que queda stale tras crear). */
export function nextReferenciaPedidoSuffix(rows) {
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return "";
  let maxSeq = 1;
  for (const row of list) {
    const ref = String(row?.Referencia || "").trim();
    const m = ref.match(/-(\d+)$/);
    if (!m) continue;
    const n = parseInt(m[1], 10);
    if (Number.isFinite(n) && n > maxSeq) maxSeq = n;
  }
  return `-${maxSeq + 1}`;
}

export function buildOptimisticA3PedidoRow(payload, resultado) {
  const docC = resultado?.documentos?.compra || {};
  const docV = resultado?.documentos?.venta || {};
  const modo = String(payload?.modo || "ambos").toLowerCase();
  const soloVenta = modo === "venta";
  const soloCompra = modo === "compra";
  const crmId = Number(resultado?.crmLink?.crmId);
  if (!Number.isFinite(crmId) || crmId <= 0) return null;

  const unidadesCompra = soloVenta ? 0 : Number(payload.unidadesCompra || 0);
  const precioCoste = soloVenta ? 0 : Number(payload.precioCoste || 0);
  const unidadesVenta = soloCompra ? 0 : Number(payload.unidadesVenta || 0);
  const precioVenta = soloCompra ? 0 : Number(payload.precioVenta || 0);

  return {
    IdPresupuestoA3Pedido: crmId,
    IdPresupuesto: payload.idPresupuesto,
    IdProyecto: payload.idProyecto,
    Referencia: String(resultado?.referencia || payload.referencia || "").trim(),
    CodArt: String(payload.codart || resultado?.codart || "").trim(),
    CodCli: String(payload.codcli || resultado?.codcli || "").trim(),
    ClienteNombre: String(payload.clienteNombre || "").trim(),
    CodPro: String(payload.codpro || resultado?.codpro || "").trim(),
    ProveedorNombre: String(payload.proveedorNombre || "").trim(),
    SerieCompra: docC.serie != null ? String(docC.serie) : null,
    NumDocCompra:
      docC.numDoc != null && docC.numDoc !== "" ? Number(docC.numDoc) : null,
    SerieVenta: docV.serie != null ? String(docV.serie) : null,
    NumDocVenta:
      docV.numDoc != null && docV.numDoc !== "" ? Number(docV.numDoc) : null,
    IdPedc: resultado?.ids?.idPedc ?? null,
    IdPedv: resultado?.ids?.idPedv ?? null,
    IdLinCompra: resultado?.ids?.idLinCompra ?? null,
    IdLinVenta: resultado?.ids?.idLinVenta ?? null,
    UnidadesCompra: unidadesCompra,
    PrecioCosteUn: precioCoste,
    TotalCompra: Number((unidadesCompra * precioCoste).toFixed(4)),
    UnidadesVenta: unidadesVenta,
    PrecioVentaUn: precioVenta,
    TotalVenta: Number((unidadesVenta * precioVenta).toFixed(4)),
    EmpresaA3: String(payload.dbSource || "STAGE_DESIGN").trim(),
    TipoContableCompra: String(payload.tipoContable || "1").trim(),
    TipoContableVenta: String(payload.tipoContable || "1").trim(),
    CreatedAt: new Date().toISOString(),
  };
}

export function a3PedidoRowReactKey(row, rowIdx = 0) {
  if (row?.IdPresupuestoA3Pedido != null) {
    return `crm-${row.IdPresupuestoA3Pedido}`;
  }
  return `tmp-${rowIdx}-${row?.IdPedc ?? "c"}-${row?.IdPedv ?? "v"}-${row?.Referencia ?? ""}`;
}
